import React, { useRef } from 'react';
import { Move, RotateCcw } from 'lucide-react';
import FocusImage from '../FocusImage';

// Drag = move focal point, slider = zoom. Preview uses the same ratio as the project cards (h-64 cards ≈ 3:2).
const FocusEditor = ({ src, focus, onChange }) => {
  const box = useRef(null);
  const dragging = useRef(false);
  const f = { x: 50, y: 50, zoom: 1, ...(focus || {}) };

  const pointToFocus = (e) => {
    const r = box.current.getBoundingClientRect();
    const x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
    const y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
    onChange({ ...f, x: Math.round(x), y: Math.round(y) });
  };

  return (
    <div className="mt-4 space-y-3" data-testid="focus-editor">
      <p className="text-sm font-medium text-gray-700 flex items-center gap-2"><Move className="h-4 w-4" />Uitsnede op de website: sleep om het focuspunt te verplaatsen, zoom met de schuifregelaar</p>
      <div
        ref={box}
        className="relative w-full max-w-md aspect-[3/2] rounded-lg cursor-move select-none touch-none ring-1 ring-gray-200"
        onPointerDown={(e) => { dragging.current = true; e.currentTarget.setPointerCapture(e.pointerId); pointToFocus(e); }}
        onPointerMove={(e) => dragging.current && pointToFocus(e)}
        onPointerUp={() => { dragging.current = false; }}
        onPointerCancel={() => { dragging.current = false; }}
        data-testid="focus-preview"
      >
        <FocusImage src={src} alt="Voorbeeld uitsnede" focus={f} className="w-full h-full rounded-lg" />
        <span className="absolute w-5 h-5 -ml-2.5 -mt-2.5 rounded-full border-2 border-white bg-[#3a190b]/80 shadow pointer-events-none" style={{ left: `${f.x}%`, top: `${f.y}%` }} aria-hidden="true" />
        <span className="absolute bottom-2 left-2 text-[10px] bg-white/85 px-2 py-0.5 rounded">Zo verschijnt de foto op de projectkaart</span>
      </div>
      <div className="flex items-center gap-3 max-w-md">
        <label htmlFor="focus-zoom" className="text-xs text-gray-600 w-14">Zoom {f.zoom.toFixed(1)}×</label>
        <input id="focus-zoom" type="range" min="1" max="2.5" step="0.1" value={f.zoom} onChange={(e) => onChange({ ...f, zoom: parseFloat(e.target.value) })} className="flex-1 accent-[#3a190b]" data-testid="focus-zoom" />
        <button type="button" onClick={() => onChange({ x: 50, y: 50, zoom: 1 })} className="inline-flex items-center gap-1 text-xs text-gray-600 hover:text-[#3a190b]" data-testid="focus-reset"><RotateCcw className="h-3 w-3" />Reset</button>
      </div>
    </div>
  );
};

export default FocusEditor;
